module.exports = __webpack_public_path__ + "img/modal-cl-claim.18e63578.svg";